// --------------------------------------------------
// FILTER BY COLLECTION OR COLOR
// --------------------------------------------------

document.addEventListener('click', function (e) {
    const btn = e.target.closest('.filter-button');
    if (!btn) return;

    e.preventDefault();

    const filterCollection = btn.dataset.filterCollection || '';
    const filterColors     = btn.dataset.filterColor || ''; // poate fi lista
    const activeColors     = filterColors ? filterColors.split(',').filter(x => x.trim() !== '') : [];

    const cards = document.querySelectorAll('[data-collections]');

    const grid = document.querySelector('.grid--uniform');
    const hidden = document.getElementById('hidden-products');

    cards.forEach(card => {
        const cardCollections = card.dataset.collections.split(',');
        const cardColors = (card.dataset.colors || '').split(',');

        let show = true;

        if (filterCollection) {
            show = cardCollections.includes(filterCollection);
        }

        if (activeColors.length > 0) {
            let matchesColor = false;
            activeColors.forEach(c => {
            if (cardColors.includes(c)) matchesColor = true;
            });
            show = show && matchesColor;
        }

        if (show) {
            if (card.parentNode !== grid) {
            grid.appendChild(card);
            }
        } else {
            if (card.parentNode !== hidden) {
            hidden.appendChild(card);
            }
        }
    });

    // UPDATE PRODUCT COUNT
    const counter = document.querySelector('.collection-filter__item--sort .inner--count');
    if (counter) {
        const visibleCount = grid.children.length;
        counter.textContent = `${visibleCount} product${visibleCount === 1 ? '' : 's'}`;
    }


    // retrigger lazyload
    document.querySelectorAll('img[data-src]').forEach(img => {
    if (!img.src) {
        img.src = img.dataset.src;
    }
    });

    if (window.lazySizes) {
        lazySizes.autoSizer.checkElems();
    }

    // reorder based on original index
    const visibleCards = Array.from(grid.children);

    visibleCards.sort((a, b) => {
    const ia = parseInt(a.dataset.index, 10);
    const ib = parseInt(b.dataset.index, 10);
    return ia - ib;
    });

    visibleCards.forEach(card => grid.appendChild(card));

    setTimeout(() => {
        if (window.theme && typeof theme.initProductGrid === 'function') {
            theme.initProductGrid();
        }

        window.dispatchEvent(new Event('resize'));
        }, 50);

    // active button UI
    document.querySelectorAll('.filter-button').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    function scrollToWithOffset(element, offset = 80) {
      const rect = element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const targetY = rect.top + scrollTop - offset;

      window.scrollTo({
        top: targetY,
        behavior: 'smooth'
      });
    }

    // scroll to product grid with offset
    const scrollTarget = document.querySelector('[data-scroll-to]');
    if (scrollTarget) {
        scrollToWithOffset(scrollTarget, 170);
    }
});


// --------------------------------------------------
// FILTER SLIDER NAVIGATION
// --------------------------------------------------

(function() {
  const slider = document.querySelector('.filter-slider__track');
  if (!slider) return;

  const btnPrev = document.querySelector('.filter-slider__prev');
  const btnNext = document.querySelector('.filter-slider__next');

  const slideAmount = 260;

  btnPrev?.addEventListener('click', () => {
    slider.scrollBy({ left: -slideAmount, behavior: 'smooth' });
  });

  btnNext?.addEventListener('click', () => {
    slider.scrollBy({ left: slideAmount, behavior: 'smooth' });
  });

  // Mouse Drag (desktop)
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', e => {
    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    slider.classList.add('dragging');
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('dragging');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('dragging');
  });

  slider.addEventListener('mousemove', e => {
    if (!isDown) return;
    e.preventDefault();

    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.5;
    slider.scrollLeft = scrollLeft - walk;
  });

  // Mobile swipe (touch)
  slider.addEventListener('touchstart', e => {
    startX = e.touches[0].pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('touchmove', e => {
    const x = e.touches[0].pageX - slider.offsetLeft;
    const walk = (x - startX) * 1.2;
    slider.scrollLeft = scrollLeft - walk;
  });
})();

// --------------------------------------------------
// SHOW/HIDE SLIDER ARROWS WHEN NEEDED
// --------------------------------------------------

function updateFilterSliderArrows() {
  const slider = document.querySelector('.filter-slider__track');
  const prev = document.querySelector('.filter-slider__prev');
  const next = document.querySelector('.filter-slider__next');

  if (!slider || !prev || !next) return;

  const hasOverflow = slider.scrollWidth > slider.clientWidth + 2;

  if (hasOverflow) {
    prev.style.display = 'flex';
    next.style.display = 'flex';
  } else {
    prev.style.display = 'none';
    next.style.display = 'none';
  }
}

// run when page loads
document.addEventListener('DOMContentLoaded', updateFilterSliderArrows);

// run when viewport changes
window.addEventListener('resize', () => {
  updateFilterSliderArrows();
  setTimeout(updateFilterSliderArrows, 150);
});

// --------------------------------------------------
// DESCRIPTION TOGGLE
// --------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.collection-description-wrapper');
  if (!wrapper) return;

  var desc = wrapper.querySelector('.collection__description');
  var btn = wrapper.querySelector('.toggle-description-btn');

  if (desc.scrollHeight <= desc.clientHeight) {
    btn.style.display = 'none';
    return;
  }

  btn.addEventListener('click', function () {
    var expanded = desc.classList.toggle('expanded');
    btn.textContent = expanded ? 'See Less' : 'See More';
  });
});